module.exports = __webpack_public_path__ + "img/LifeDeath.7f9df124.jpg";